import type { DashboardRookieMemberDto, RookieMilestone } from "@/modules/boxDashboard/gateway/boxDashboardApiDto"
import { word } from "@/modules/core/utils/i18n"
import type { HUImage } from "@/modules/types/imageTypes"
import dayjs from "dayjs"

export class RookieMemberEntity {
  constructor(
    public readonly id: string,
    public readonly memberId: string,
    public readonly firstname: string | null,
    public readonly lastname: string | null,
    public readonly username: string | null,
    public readonly avatar: HUImage | null,
    public readonly nbOfDaysSinceRegistration: number,
    public readonly totalSessions: number,
    public readonly lastSessionDate: string | null,
    public readonly nextSessionDate: string | null,
    public readonly purchaseName: string,
    public readonly archived: boolean,
    public readonly createdDate: string,
  ) {}

  static fromDto(dto: DashboardRookieMemberDto): RookieMemberEntity {
    return new RookieMemberEntity(
      dto.id,
      dto.member.id,
      dto.member.firstname,
      dto.member.lastname,
      dto.member.username,
      dto.member.avatar,
      dto.nbOfDaysSinceRegistration,
      dto.totalSessions,
      dto.lastSessionDate,
      dto.nextSessionDate,
      dto.purchaseName,
      dto.archived,
      dto.createdDate,
    )
  }

  getFullName(): string {
    return `${this.firstname ?? ""} ${this.lastname ?? ""}`
  }

  getDaysLabel(): string {
    return `${this.nbOfDaysSinceRegistration}${word("global.day.label", { count: 1 })[0]}`
  }

  getLastSessionDateFormatted(): string | null {
    if (!this.lastSessionDate) return null
    return dayjs(this.lastSessionDate).format("L")
  }

  getNextSessionDateFormatted(): string | null {
    if (!this.nextSessionDate) return null
    return dayjs(this.nextSessionDate).format("L")
  }

  getMilestone(): RookieMilestone {
    if (this.nbOfDaysSinceRegistration < 15) return "UNDER_15_DAYS"
    if (this.nbOfDaysSinceRegistration < 30) return "UNDER_30_DAYS"
    if (this.nbOfDaysSinceRegistration < 45) return "UNDER_45_DAYS"
    return "UNDER_60_DAYS"
  }
}
